import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const radioOnlyIconGroupRootFn = /* @__PURE__ */ createRecipe('radio-icon-group-root', {}, [])

const radioOnlyIconGroupRootVariantMap = {}

const radioOnlyIconGroupRootVariantKeys = Object.keys(radioOnlyIconGroupRootVariantMap)

export const radioOnlyIconGroupRoot = /* @__PURE__ */ Object.assign(memo(radioOnlyIconGroupRootFn.recipeFn), {
  __recipe__: true,
  __name__: 'radioOnlyIconGroupRoot',
  __getCompoundVariantCss__: radioOnlyIconGroupRootFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: radioOnlyIconGroupRootVariantKeys,
  variantMap: radioOnlyIconGroupRootVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, radioOnlyIconGroupRootVariantKeys)
  },
  getVariantProps: radioOnlyIconGroupRootFn.getVariantProps,
})